const EVENT_TYPES = {
    FEATURE_ACTIVATE: "feature_activate",
    FEATURE_COMPLETE: "feature_complete",
    FEATURE_CLICK: "feature_click",
    FEATURE_VIEW: "feature_view",
    FEATURE_SETTINGS: "feature_settings"
} as const;

const FEATURE_CATEGORIES = {
    PREFLIGHT: "Pre-flight",
    NAVIGATION: "navigation",
    CAMPAIGN: "Campaign",
    DELIVERABLES: "Deliverables",
    CLIENT: "Client",
    MASTER_TEMPLATES: "Master Templates",
    CREATIVE_LIBRARY_DOWNLOAD: "Creative Library - Download",
    SHARE: "Share",
    IMPORT_EXPORT: "Import/Export",
    QA_DRAWER: "QA Drawer"
} as const;

const FEATURE_CONTEXTS = {
    PREFLIGHT_REPORT: "Pre-flight report",
    HEADER: "header",
    SIDEBAR: "sidebar",
    EDIT_CLIENT: "Edit Client",
    DELETE_CLIENT: "Delete Client",
    ADD_CLIENT: "Add Client",
    REVIEW_DELIVERABLES: "Quality assurance",
    CLOSE_REVIEW_DELIVERABLES: "Close Review deliverables",
    ADD_CAMPAIGN: "Add Campaign",
    MASTER_TEMPLATES: "Master Templates",
    CREATIVE_LIBRARY_DOWNLOAD: "Creative Library - Download",
    CANCEL_DOWNLOAD: "Cancel download",
    DOWNLOAD_SUCCESSFUL: "Download Successful",
    SHARE_PREVIEW_LINKS: "Share Preview Links",
    CANCEL_SHARE_PREVIEW_LINKS: "Cancel Share Preview Links",
    SEND_PREVIEW_LINKS: "Send Preview Links",
    ADD_TEMPLATE: "Add Template",
    REPLACE_TEMPLATE: "Replace Template",
    UPDATE_TEMPLATE: "Update Template",
    IMPORT_EXPORT: "Import/Export Upload",
    CLOSE_IMPORT_EXPORT: "Close Import/Export Upload",
    ADD_NEW_ANNOTATION: "Add New Annotation",
    CANCEL_ADD_ANNOTATION: "Cancel Add Annotation"
} as const;

const CLICK_INTERACTION_OBJECTS = {
    BUTTON: "Button",
    LINK: "Link",
    ICON: "Icon",
    DROPDOWN: "Dropdown",
    CHECKBOX: "Checkbox",
    TAB: "Tab"
} as const;

const CLICK_INTERACTION_TEXTS = {
    SELECT_ALL: "Select All",
    DESELECT_ALL: "Deselect All",
    APPROVE_BANNER: "Approve Banner",
    REJECT_BANNER: "Reject Banner",
    OMS_CHANNEL_SELECTED: "OMS Channel Selected",
    GET_SHAREABLE_LINKS: "Get shareable links",
    COPY_PREVIEW_LINK: "Copy preview link",
    COPY_ALL_PREVIEW_LINKS: "Copy all preview links",
    PREVIEW_TAB: "Preview Tab",
    QUALITY_ASSURANCE_TAB: "Quality Assurance Tab",
    COPY_FEED_URL: "Copy Feed URL",
    TOGGLE_DELIVERABLE: "Toggle Deliverable with ID",
    SET_STATUS: "Set Banner Status",
    TEMPLATE_OPTIONS: "Template Options",
    APPROVE_ALL_DELIVERABLES: "Approve all deliverables",
    REJECT_ALL_DELIVERABLES: "Reject all deliverables",
    AD_SCALING: "Ad scaling",
    REPLAY_BANNER: "Replay Banner",
    DOWNLOAD_TEMPLATE: "Download Template",
    SHOW_RESOLVED: "Show Resolved",
    DELETE_ANNOTATION: "Delete Annotation",
    EDIT_ANNOTATION: "Edit Annotation"
} as const;

const ERROR_TYPES = {
    VALIDATION_ERROR: "validation_error",
    SYSTEM_ERROR: "system_error",
    NETWORK_ERROR: "network_error"
} as const;

const ERROR_ORIGINS = {
    FRONTEND: "frontend",
    BACKEND: "backend",
    THIRD_PARTY: "third_party"
} as const;

const SEGMENT_NAMES = {
    REPLAY_BANNER: "Replay Banner",
    SCALING_BUTTON: "Scaling Button",
    MASTER_TEMPLATES_SCALING: "Master Template Scaling Toggle"
} as const;

const SEGMENT_CATEGORIES = {
    PLAYBACK_CONTROLS: "Playback Controls"
} as const;

const SEGMENT_INTERACTIONS = {
    CLICK: "click",
    VIEW: "view",
    DOWNLOAD: "download",
    REPLAY: "replay"
} as const;

export default {
    EVENT_TYPES,
    FEATURE_CATEGORIES,
    FEATURE_CONTEXTS,
    CLICK_INTERACTION_OBJECTS,
    CLICK_INTERACTION_TEXTS,
    ERROR_TYPES,
    ERROR_ORIGINS,
    SEGMENT_NAMES,
    SEGMENT_CATEGORIES,
    SEGMENT_INTERACTIONS
} as const;
